import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DealsComponent } from './deals.component';
import { TileContainerModule } from '../tileContainer/tile.container.module';

import { FilterContainerModule } from '../filterContainer/filter.container.module';
import { ResultsSummaryModule } from '../resultsSummary/results.summary.module';
import { MobileMenuModule } from '../mobileMenu/mobilemenu.module';
import { ResetFormModule } from '../resetForm/reset.form.module';

@NgModule({
  imports: [
    CommonModule,
    TileContainerModule,
    FilterContainerModule,
    ResultsSummaryModule,
    ResetFormModule,
    MobileMenuModule,
    DealsComponent,
  ],
  exports: [DealsComponent],
})
export class DealsModule {}
